"use strict";

$.widget("fotobook.containereditorbasecontrol", {
    "options" : {
        "disabledClass" : "ui-state-disabled",
    },
    containerId: null,
    getContainer: function(){
        return this.options.container;
    },
    getContainerId: function(){
        if (!this.containerId){
            this.containerId = parseInt(this.getContainer().attr("data-id"), 10);
        }
        return this.containerId;
    },

    _create: function(){
        this._on(true, this.options.container, {
            "containereditorcheckbuttons" : this._containerChanged,
        });
        var events = {};
        events[Fotobook.events.EDITOR_TOOLBAR_MOVED] = this._widgetMoved;
        this._on(false, this.options.toolbar, events);

        this._on(false, this.element, {
            "click" : this._processClick,
        });
    },

    _setOptionDisabled: function(value){
        this._toggleClass( this.widget(), this.options.disabledClass, null, !!value );
        this._super();
    },

    _checkEnabled: $.noop,

    _containerChanged: function(){
        var enabled = this._checkEnabled();
        if (typeof enabled === "boolean"){
            if (enabled){
                this.enable();
            } else {
                this.disable();
            }
        }
    },
    _widgetMoved: $.noop,
    _processClick: $.noop,
    _destroy: function(){
        this.options.editorWidget = null;
    },
});


// базовый класс для дропдаунов. открывает/закрываем дропаун, позиционирует его
$.widget("fotobook.containereditordropdownbase", $.fotobook.containereditorbasecontrol, {
    "options" : {
        "closeOnSelect" : true,
        "position" : {
            "my": "left top",
            "at": "left bottom",
            "collision": "flip",
        },
    },
    dropdown: null,
    dropdownOpened: false,
    _create: function(){
        this._super();
        this.dropdown = this._createDropdown();
        this.element.append(this.dropdown);
        this._on(this.dropdown, {
            "click .dropdown-item" : this._processItemClick,
        });
    },
    _setOptionDisabled: function(value){
        this._super();
        if (value){
            this._closeDropdown();
        }
    },
    _toggleDropdown: function(activate){
        var currentState = this.element.hasClass("active");

        if (activate === undefined){
            activate = !currentState;
        }
        activate = !!activate;

        if (activate === currentState){
            return this;
        }
        if (!activate){
            this._off(this.document);
        }
        this.element.toggleClass("active", activate);
        if (activate){
            this._position();
            this._on(this.document, this.__documentClick);
        }
        this.dropdownOpened = activate;
        return this;
    },
    _position: function() {
        this.dropdown.position($.extend({
            "of": this.element,
        }, this.options.position));
    },
    _closeDropdown: function(){
        return this._toggleDropdown(false);
    },
    _openDropdown: function(){
        return this._toggleDropdown(true);
    },
    _processClick: function(event){
        if ($(event.target).closest(this.dropdown).length){
            return;
        }
        this._toggleDropdown();
        this._super();
    },
    _processItemClick: function(event){
        if (this.options.closeOnSelect){
            this._closeDropdown();
        }
    },
    __documentClick: {
        "mousedown" : function(event){
            if ($(event.target).closest(this.element.add(this.dropdown)).length){
                return;
            }
            this._closeDropdown();
        },
    },
    _widgetMoved: function(){
        if (this.dropdownOpened){
            this._position();
        }
    },
});
